<template>
  <div class="animate-pulse rounded-md bg-[#eaeef5]" />
</template>
